export default "__VITE_ASSET__Bwj01gWI__"